 export default {

    // app settings
    version:'1.1',
    vuexLocalStorageName: 'pak_game'

};
